export type CommentQuickViewId = "all" | "action" | "historia" | "cta" | "pytanie" | "atak";

export const COMMENT_QUICK_VIEWS: {
  id: CommentQuickViewId;
  label: string;
  description: string;
}[] = [
  { id: "all", label: "Wszystkie", description: "Pełny korpus z plików kanałów." },
  { id: "action", label: "Do akcji", description: "Wysoki score: ból, pytanie, zakup." },
  { id: "historia", label: "Historie", description: "Sceny pierwszej osoby pod rolką." },
  { id: "cta", label: "CTA Mama", description: "Krótkie hasła ManyChat." },
  { id: "pytanie", label: "Pytania", description: "Pytają, nie tylko reagują." },
  { id: "atak", label: "Atak formy", description: "Hejt min, krzyku, „aktorki”." },
];

export const PLATFORM_LABEL: Record<string, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  youtube: "YouTube",
  tiktok: "TikTok",
};

export const CLASS_ORDER = [
  "historia_identyfikacja",
  "pytanie",
  "cta_only",
  "produkt_zakup",
  "atak_forma",
  "obrona_matek",
  "wsparcie",
  "krotka_reakcja",
  "inne",
];

export const CLASS_LABELS: Record<string, string> = {
  cta_only: "CTA Mama",
  atak_forma: "Atak formy",
  obrona_matek: "Obrona matek",
  produkt_zakup: "Produkt",
  historia_identyfikacja: "Historia",
  pytanie: "Pytanie",
  wsparcie: "Wsparcie",
  krotka_reakcja: "Krótka",
  inne: "Inne",
};

export const PAIN_LABELS: Record<string, string> = {
  B1: "Boi się być jak matka / echo",
  B2: "Telefon / ciało reaguje",
  B3: "Grzeczność / tłumaczenie się",
  B4: "Poczucie winy",
  B5: "Ciało / wygląd",
  B6: "Babcia / wnuki",
  B7: "Opieka / wypalenie",
  B8: "Dorosła córka / wiek",
  B9: "Żałoba / strata",
  B10: "Tata / ojciec",
  B11: "Granice / karta",
  B12: "Konflikt / tarcie",
  B13: "Przemoc",
  B14: "Dom / wyprowadzka",
  B15: "Zazdrość / przyjaciółka / mama jej vs twoja",
  B16: "Zaufanie / sekret / kobiety",
  B17: "Nie histeryzuj / nic się nie stało",
  B18: "Rodzeństwo / rywalizacja / etykieta z domu",
  B19: "Nie będę mieć dziecka / schemat",
};

export function platformLabel(id: string): string {
  return PLATFORM_LABEL[id] || id;
}

export function classLabel(id: string): string {
  return CLASS_LABELS[id] || id;
}

export function painLabel(id: string, catalogLabel?: string): string {
  const name = (catalogLabel || PAIN_LABELS[id] || "ból z katalogu").trim();
  if (!id) return name;
  if (name.toLowerCase().startsWith(id.toLowerCase())) return name;
  return `${id} ${name}`;
}

export function freshnessLabel(status: string): string {
  if (status === "live") return "żywy";
  if (status === "stale") return "stary";
  if (status === "cold") return "zimny";
  return "brak";
}

const MISSING_AUTHOR = new Set(["", "?", "unknown", "anonim", "anonymous", "null", "none"]);

/** Graph FB często oddaje "?"; nie pokazuj tego użytkownikowi. */
export function displayAuthorName(
  author: string | null | undefined,
  platformOrSource?: string | null,
): string {
  const raw = String(author || "").trim();
  if (raw && !MISSING_AUTHOR.has(raw.toLowerCase()) && raw !== "?") return raw;

  const key = String(platformOrSource || "").trim().toLowerCase();
  if (key === "comment_ig" || key === "dm_ig" || key === "instagram" || key === "ig" || key === "ins") {
    return "Czytelniczka IG";
  }
  if (
    key === "comment_fb" ||
    key === "dm_fb" ||
    key === "facebook" ||
    key === "fb" ||
    key === "fac" ||
    key === "messenger"
  ) {
    return "Czytelniczka FB";
  }
  return "Czytelniczka";
}
